<!-- v1.6.1538 — billing notice (Asana 1218431462710845).
     Shown for warning AND restricted: during the warning period every screen
     keeps working, so this is the only thing telling staff a deadline exists. -->
<!-- v1.6.1572 — the status could not be READ. Without this, a failed check is
     indistinguishable from a clean bill: the verdict degrades to allowed and
     the banner stays down. -->
<div *ngIf="readErrorVisible" class="px-4 py-3 border-b bg-amber-50 border-amber-200">
  <div class="max-w-7xl mx-auto flex items-start gap-3">
    <i class="fa-solid fa-triangle-exclamation text-amber-600 text-sm mt-0.5"></i>
    <div class="flex-1">
      <p class="text-sm text-amber-900 m-0">{{ readError }}</p>
      <button (click)="refresh()" class="text-xs text-amber-800 underline mt-1">Try again</button>
    </div>
  </div>
</div>

<!-- v1.6.1570 — grace: the state is `allowed`, so the banner below stays down
     and this is the only thing that would mention a balance running out of
     cover. Informational, not a warning. -->
<div *ngIf="graceVisible" class="px-4 py-3 border-b bg-blue-50 border-blue-200">
  <div class="max-w-7xl mx-auto flex items-start gap-3">
    <i class="fa-solid fa-circle-info text-blue-600 text-sm mt-0.5"></i>
    <p class="text-sm text-blue-900 m-0">{{ graceNote }}</p>
  </div>
</div>

<div *ngIf="visible" class="px-4 py-3 border-b"
     [ngClass]="status.state === 'restricted'
                ? 'bg-red-50 border-red-200' : 'bg-amber-50 border-amber-200'">
  <div class="max-w-7xl mx-auto flex items-start gap-3">
    <i class="fa-solid text-sm mt-0.5"
       [ngClass]="status.state === 'restricted'
                  ? 'fa-lock text-red-600' : 'fa-triangle-exclamation text-amber-600'"></i>

    <div class="flex-1 min-w-0">
      <p class="text-sm font-semibold m-0"
         [ngClass]="status.state === 'restricted' ? 'text-red-900' : 'text-amber-900'">
        {{ copy.headline }}
      </p>
      <p class="text-sm mt-0.5 mb-0"
         [ngClass]="status.state === 'restricted' ? 'text-red-800' : 'text-amber-800'">
        {{ copy.supporting }}
      </p>

      <!-- The server's own wording, shown verbatim as the spec requires. It
           explains the state better than anything generic we could write. -->
      <p *ngIf="status.message && !paymentInProgress" class="text-xs mt-1.5 mb-0"
         [ngClass]="status.state === 'restricted' ? 'text-red-700' : 'text-amber-700'">
        {{ status.message }}
      </p>

      <!-- Staff get asked about this before they're told, so it's on screen. -->
      <p *ngIf="storefrontLine && !paymentInProgress" class="text-xs mt-1 mb-0 font-medium"
         [ngClass]="status.state === 'restricted' ? 'text-red-700' : 'text-amber-700'">
        {{ storefrontLine }}
      </p>

      <p *ngIf="payError" class="text-xs text-red-700 mt-1.5 mb-0">{{ payError }}</p>
    </div>

    <div class="shrink-0 flex items-center gap-2">
      <!-- Only when the server says pay_now_available AND the staff member has
           billing_payment.create. Paying does not lift a manual block, so the
           copy points at support in that case instead. -->
      <button *ngIf="canPay && !paymentInProgress" (click)="payNow()" [disabled]="paying"
              class="px-4 py-2 rounded-lg text-sm font-semibold text-white disabled:opacity-50"
              [ngClass]="status.state === 'restricted' ? 'bg-red-600 hover:bg-red-700'
                                                       : 'bg-amber-600 hover:bg-amber-700'">
        {{ paying ? 'Opening…' : 'Pay now' }}
      </button>
      <!-- 429: disabled for exactly as long as the server asked. -->
      <span *ngIf="retryIn > 0" class="text-xs text-gray-600">Try again in {{ retryIn }}s</span>

      <button *ngIf="paymentInProgress" (click)="refresh()"
              class="px-3 py-2 rounded-lg text-sm font-medium border border-gray-300 text-gray-700 hover:bg-white">
        <i class="fa-solid fa-rotate mr-1"></i>Check again
      </button>
    </div>
  </div>
</div>
